// extracted by mini-css-extract-plugin
module.exports =  {"root":"tEvAX9LzdqINYLiIi0sW"};